<script lang="ts">
  import { tick } from 'svelte';
  import { namePrompt, resolveNamePrompt, type NamePromptRequest } from '../lib/namePrompt';

  let value = '';
  let input: HTMLInputElement;
  let activeRequest: NamePromptRequest | null = null;

  $: if ($namePrompt && $namePrompt !== activeRequest) {
    activeRequest = $namePrompt;
    value = $namePrompt.defaultValue;
    tick().then(() => { input?.focus(); input?.select(); });
  }
  $: if (!$namePrompt) activeRequest = null;

  function submit() {
    const trimmed = value.trim();
    if (trimmed) resolveNamePrompt(trimmed);
  }

  function onKeydown(event: KeyboardEvent) {
    if ($namePrompt && event.key === 'Escape') resolveNamePrompt(null);
  }
</script>

<svelte:window on:keydown={onKeydown} />

{#if $namePrompt}
  <div class="name-modal-backdrop" role="presentation" on:click={(e) => e.target === e.currentTarget && resolveNamePrompt(null)}>
    <div class="name-modal" role="dialog" aria-modal="true" aria-labelledby="name-modal-title">
      <form on:submit|preventDefault={submit}>
        <h2 id="name-modal-title">{$namePrompt.title}</h2>
        <label for="entity-name">{$namePrompt.label}</label>
        <input bind:this={input} bind:value id="entity-name" type="text" autocomplete="off" />
        <div class="name-modal-actions">
          <button type="button" class="secondary" on:click={() => resolveNamePrompt(null)}>Cancel</button>
          <button type="submit" disabled={!value.trim()}>Add pin</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style>
  .name-modal-backdrop {
    position: fixed;
    z-index: 2000;
    inset: 0;
    display: grid;
    place-items: center;
    padding: 20px;
    background: rgba(20, 31, 25, 0.42);
    backdrop-filter: blur(2px);
  }
  .name-modal {
    width: min(360px, 100%);
    padding: 22px;
    background: var(--panel);
    border: 1px solid var(--line);
    border-radius: 14px;
    box-shadow: 0 18px 60px rgba(20, 31, 25, 0.28);
  }
  h2 {
    margin: 0 0 16px;
    color: var(--ink);
    font-family: var(--serif);
    font-size: 26px;
    font-style: italic;
    font-weight: 400;
    line-height: 1.1;
  }
  .name-modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
</style>
